// src/components/messages/useMessageAlertDing.ts
// Dev-sync note f8ff1ac3 — plays a soft chime whenever the workplace-messages
// unread count rises. Skips the very first observation so we don't ding on app
// open. Respects the user toggle in localStorage so a quiet floor stays quiet.
import { useEffect, useRef, useState } from "react";
import {
  detectUnreadIncrease,
  getMessageAlertEnabled,
  maybeShowDesktopMessageAlert,
  playMessageDing,
  subscribeMessageAlertSettings,
} from "@/lib/messages/messageAlertAudio";

export function useMessageAlertDing(unreadCount: number): { enabled: boolean } {
  const [enabled, setEnabled] = useState<boolean>(() => getMessageAlertEnabled());
  const prevUnreadRef = useRef<number | null>(null);

  useEffect(() => subscribeMessageAlertSettings(setEnabled), []);

  useEffect(() => {
    const prev = prevUnreadRef.current;
    prevUnreadRef.current = unreadCount;
    if (!enabled) return;
    if (detectUnreadIncrease(prev, unreadCount)) {
      playMessageDing();
      maybeShowDesktopMessageAlert();
    }
  }, [unreadCount, enabled]);

  return { enabled };
}
